cockpitApp.filter('isDate', function() {
  return function(date) {
    return moment(date).isValid();
  }
});
